import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSearch } from "react-icons/fa";
import TextField from '@mui/material/TextField';
import { ApiLink } from '../../APILink/ApiLink';
import authHeader from '../../Auth/authHeader';
import { errorAlert } from '../../Components/Alerts';
import Autocomplete from "@mui/material/Autocomplete";
import '../../Style/Kartela.scss';
import AgentDetails from './Details/AgentDetails';

export default function KartelaAgjentit(props) {
    const headers = authHeader();

    const [agent, setAgent] = useState([]);
    const [agentID, setAgentID] = useState(0)

    const [openDetails, setOpenDetails] = useState(false); // Deklarimi i useState


    const [accField, setAccfield] = useState(null)
    const [accName, setAccName] = useState(null)

    const handleAutocompleteChangeAgent = (event, value) => {
        if (value && value.Id) {
            setAgentID(value.Id);
            setAccfield(value);
            setAccName(value.UserName);
        } else {
            // Në rast se vlera është pastruar
            setAgentID(""); // Vendos vlerën e ArticleID në null
        }
    };

    const defaultPropsAgent = {
        options: agent,
        getOptionLabel: (option) =>
            option.UserName || "",
        renderOption: (props, option) => (
            <>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                    <span>
                        {/* {option.Id}<br /> */}
                        {option.UserName}
                    </span>
                </li>
            </>
        ),
    };

    const showCard = () => {
        if (agentID != 0) {
            setOpenDetails(true);
        }
        else {
            setOpenDetails(false);
            errorAlert("Ju lutem zgjedhni klientin")
        }
    }

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Users/getusers', { headers });
            setAgent(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    // const fetchClients = async () => {
    //     try {
    //         const response = await axios.get(ApiLink.API_URL + 'Accounts/accountByLedger', { headers, params: { ledger: 105 } });
    //         setClients(response.data);
    //     } catch (error) {
    //         errorAlert("Gabim në kërkesë:", error);
    //         if (error.response && error.response.data && error.response.data.errorMessage) {
    //             errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
    //         } else if (error.message) {
    //             errorAlert(`Gabim: ${error.message} `);
    //         } else {
    //             errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
    //         }
    //     }
    // };

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <div className='KartelaKlientit__Container'>
            {
                openDetails ?
                    <AgentDetails accountID={agentID} accName={accName} />
                    :
                    <div className="KartelaKlientit__Container__FirstDiv">
                        <div className='KartelaKlientit__Container__FirstDiv__Input'>
                            <Autocomplete
                                {...defaultPropsAgent}
                                id="include-input-in-list"
                                className='KartelaKlientit__Container__FirstDiv__Input__AutoComplete'
                                includeInputInList
                                value={accField}
                                onChange={handleAutocompleteChangeAgent}
                                isOptionEqualToValue={(option, value) => option.Id === value.Id} // Shto funksionin isOptionEqualToValue
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="KartelaKlientit__Container__TextField"
                                        // style={{ width: "55% " }}
                                        label="Zgjedh Agjentin"
                                    />
                                )}
                            />
                        </div>
                        <div className='KartelaKlientit__Container__FirstDiv__Button'>
                            <button className="button-68" variant="contained" onClick={() => showCard()}><FaSearch /> Shfaq Kartelen</button>
                        </div>
                    </div>
            }
            {/* </div> */}
        </div>
    );
};
